import basePath from './basePath'

const TimeIn = () => import(/* webpackChunkName: "group-time-in" */ '@/components/timeIn/time-in')
const TimeInList = () => import(/* webpackChunkName: "group-time-in" */ '@/components/timeIn/mainLayout/main-layout-list')
const TimeInEdit = () => import(/* webpackChunkName: "group-time-in" */ '@/components/timeIn/time-in-edit')
const TimeInDetail = () => import(/* webpackChunkName: "group-time-in" */ '@/components/timeIn/mainLayout/main-layout-detail')

export default {
  path: `/${basePath.timeIn}`,
  component: TimeIn,
  meta: {
    requiresAuth: true
  },

  children: [{
    path: '',
    component: TimeInList
  },
  {
    path: 'list',
    component: TimeInList
  },
  {
    path: 'new',
    component: TimeInEdit
  },
  {
    path: 'detail/:id',
    component: TimeInDetail,
    props: true
  }]
}
